import englishMessages from './en.json';

const mapping = {
  en: englishMessages
};

export const getMessages = locale => {
  if (mapping[locale]) {
    return mapping[locale];
  }
  return mapping.en;
};
